import { render, staticRenderFns } from "./index.vue?vue&type=template&id=953d1bc6&scoped=true&v=1.0.1"
import script from "./index.vue?vue&type=script&lang=js&v=1.0.1"
export * from "./index.vue?vue&type=script&lang=js&v=1.0.1"
import style0 from "./index.vue?vue&type=style&index=0&id=953d1bc6&prod&scoped=true&lang=css&v=1.0.1"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953d1bc6",
  null
  
)

export default component.exports